import {desktopMinWidth} from "../../_common/breakPoints";
/**
 * initialize event listener for quantity modifier button
 */
export const featureBanner = (function () {
  'use strict';

  var breakpoint = desktopMinWidth

  var init = function () {
    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);
    // kickstart
    breakpointChecker();
  };


  var breakpointChecker = function () {
    var banner = document.querySelector("#product-listing-banner");
    var productTile = document.querySelectorAll(".product-listing-tile");
    // For larger screen size
    if (breakpoint.matches === true) {
      if(banner !== null && productTile[2] && productTile[2].parentNode) {
        productTile[2].parentNode.insertBefore(banner, productTile[2].nextSibling);
      }
    } else if (breakpoint.matches === false) {
      if(banner !== null && productTile[1] && productTile[1].parentNode) {
        productTile[1].parentNode.insertBefore(banner, productTile[1].nextSibling);
      }
    }
  };

  return {
    init: init
  };

});



// WEBPACK FOOTER //
// ./javascript/product-search-page/raw-from-relab/plp-product-grid.js